import { useContext } from 'react';
import { PreferencesEditorContext, } from './PreferencesEditorContext';
export var usePreferencesEditor = function () {
    var context = useContext(PreferencesEditorContext);
    if (!context) {
        throw new Error('usePreferencesEditor must be used within a PreferencesEditorContextProvider');
    }
    return context;
};
//# sourceMappingURL=usePreferencesEditor.js.map